import { Modal } from '@mui/material';
import { useEffect, useState } from 'react';
import BackArrow from '../../assets/Modals/BackArrow';
import ChatModalOptions from '../../assets/Modals/ChatModalOptions';
import SearchIcon from '../../assets/Modals/SearchIcon';
import { useMessages } from '../../contexts/messages';
import { ChatMessageType, SendMessageType } from '../../services/apiTypes';
import { normalizeHeight, normalizeWidth } from '../../utils/normalize';
import InputLogin from '../InputLogin';
import Chat from './Chat';
import InboxMessage from './InboxMessage';
import ChatModal from './Modals/ChatModal';
import SelectionHeader from './SelectionHeader';
import { BackIconWrapper, ChatBoxContainer, ChatBoxHeader, HeaderTitle, InboxMessagesContainer, InputContainer, MessageInput, SearchContainer, SendButton, SolicitationsText } from './styles';


type ChatBoxProps = {
  open: boolean;
  onClose: any;
}

const containers = [
  {
    name: 'inbox',
    title: 'Caixa de mensagens',
  },
  {
    name: 'solicitations',
    title: 'Solicitações de mensagens',
  },
  {
    name: 'chat',
    title: 'Chat',
  }
]

export default function ChatBox({ open, onClose }: ChatBoxProps) {
  const { chats, chatSolicitations, selectedChat, setSelectedChat, sendMessage } = useMessages();
  const [selectedContainer, setSelectedContainer] = useState<{ name: string, title: string }>(containers[0]);
  const [search, setSearch] = useState<string>('');
  const [selectingMessages, setSelectingMessages] = useState<boolean>(false);
  const [selectedMessages, setSelectedMessages] = useState<ChatMessageType[]>([]);
  const [chatOptionsModalOpen, setChatOptionsModalOpen] = useState<boolean>(false);
  const [answeringMessage, setAnsweringMessage] = useState<ChatMessageType>();

  const onChatClick = (index: number) => {
    setSelectedContainer(containers[2]);
    console.log(chats[index]);
    setSelectedChat(chats[index]);
  }

  const handleGoBack = () => {
    switch (selectedContainer.name) {
      case 'solicitations':
        setSelectedContainer(containers[0]);
        break;
      case 'chat':
        setSelectedContainer(containers[0]);
        setSelectedChat(undefined);
        break;
      default:
        onClose(false);
    }
  }

  const handleMessageSelection = (message: ChatMessageType) => {
    if (selectedMessages.includes(message)) {
      setSelectedMessages(selectedMessages.filter((m) => m !== message));
    } else {
      setSelectedMessages([...selectedMessages, message]);
    }
  }

  const handleCancelSelection = () => {
    setSelectedMessages([]);
    setSelectingMessages(false);
  }

  useEffect(() => {
    if (selectedMessages.length === 0) {
      setSelectingMessages(false);
    } else {
      setSelectingMessages(true);
    }
  }, [selectedMessages])

  const [messageInput, setMessageInput] = useState<string>('');
  const handleKeyPress = async (e: any) => {
    if (e !== 'Enter') {
      setMessageInput(e.target.value);
    }
    if (e.key === 'Enter' || e === 'Enter') {
      console.log('sending message');
      const message = {
        roomId: selectedChat?.id,
        parentId: selectedChat?.id,
        receiverId: selectedChat?.participants[0].userId,
        content: messageInput,
      }
      sendMessage(message as SendMessageType);
      setMessageInput('');
      setAnsweringMessage(undefined);
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => onClose(false)}
      hideBackdrop={true}
      disableScrollLock={true}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      style={{
        left: '72%',
        top: normalizeHeight(56),
        borderRadius: 10,
        height: normalizeHeight(820),
        width: normalizeWidth(340),
        outline: 0,
      }}>
      <ChatBoxContainer>
        <ChatBoxHeader>
          {!selectingMessages ? (
            <div style={{ height: '32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <BackIconWrapper onClick={() => handleGoBack()}>
                <BackArrow />
              </BackIconWrapper>
              <HeaderTitle>{selectedChat ? selectedChat.name : selectedContainer.title}</HeaderTitle>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {selectedChat && (
                  <BackIconWrapper onClick={(selectedChat && selectedChat.name) ? () => setChatOptionsModalOpen(!chatOptionsModalOpen) : () => { }}>
                    <ChatModalOptions />
                    {selectedChat && <ChatModal open={chatOptionsModalOpen} authorUsername={selectedChat.name} onAction={(action: string) => console.log(action)} />}
                  </BackIconWrapper>
                )}
                <BackIconWrapper>
                  <ExpandIcon />
                </BackIconWrapper>
              </div>
            </div>
          ) : (
            <SelectionHeader selectedMessages={selectedMessages} cancelSelection={handleCancelSelection} />
          )}
        </ChatBoxHeader>
        {selectedContainer.name === 'inbox' && (
          <SearchContainer>
            <SolicitationsText
              onClick={() => setSelectedContainer(containers[1])}
            >
              solicitações ({chatSolicitations})
            </SolicitationsText>
            <InputLogin
              placeholder="Pesquisar"
              value={search}
              type='text'
              icon={<SearchIcon />}
              handler={(e) => setSearch(e.target.value)}
            />
          </SearchContainer>
        )}
        {selectedContainer.name === 'inbox' && (
          <InboxMessagesContainer>
            {chats && chats.map((message, index) => (
              <InboxMessage
                key={message.name}
                updatedAt={message.updatedAt}
                id={message.id}
                participants={message.participants}
                type={message.type}
                messages={message.messages}
                avatarUrl={message.participants[0].userAvatarUrl}
                name={message.name}
                onClick={() => onChatClick(index)}
              />
            ))}
          </InboxMessagesContainer>
        )}
        {selectedContainer.name === 'solicitations' && (
          <InboxMessagesContainer>
            <h1>Solicitations</h1>
          </InboxMessagesContainer>
        )}
        {selectedContainer.name === 'chat' && selectedChat && (
          <>
            <InboxMessagesContainer>
              <Chat
                username={selectedChat.name}
                messages={selectedChat.messages || []}
                handleMessageSelection={handleMessageSelection}
                selectingMessages={selectingMessages}
                answeringMessage={answeringMessage}
                setAnsweringMessage={setAnsweringMessage}
              />
            </InboxMessagesContainer>
            <InputContainer>
              <MessageInput
                value={messageInput}
                onKeyUp={handleKeyPress}
                onChange={(e) => setMessageInput(e.target.value)}
                placeholder="Enviar mensagem"
              />
              {messageInput.length > 0 && (
                <SendButton style={{ cursor: 'pointer' }} onClick={() => handleKeyPress('Enter')}>
                  Enviar
                </SendButton>
              )}
            </InputContainer>
          </>
        )}
      </ChatBoxContainer>
    </Modal>
  )
}

function ExpandIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        stroke="#999"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.778"
        d="M11.666 1h5.333v5.333M6.333 17H1v-5.334M17 1l-6.223 6.222M1 17l6.222-6.223"
      ></path>
    </svg>
  );
}